import type { AuthHeaders } from '../client'
import { request } from '../client'
import type {
  AuthorizedClub,
  CreateAuthorizedClubRequest,
  UpdateAuthorizedClubRequest,
} from '../types'

export function listClubs(
  auth: AuthHeaders,
): Promise<{ clubs: AuthorizedClub[] }> {
  return request<{ clubs: AuthorizedClub[] }>('/admin/clubs', { auth })
}

export function createClub(
  auth: AuthHeaders,
  body: CreateAuthorizedClubRequest,
): Promise<AuthorizedClub> {
  return request<AuthorizedClub>('/admin/clubs', {
    method: 'POST',
    body,
    auth,
  })
}

export function getClub(
  auth: AuthHeaders,
  clubname: string,
): Promise<AuthorizedClub> {
  return request<AuthorizedClub>(
    `/admin/clubs/${encodeURIComponent(clubname)}`,
    { auth },
  )
}

export function updateClub(
  auth: AuthHeaders,
  clubname: string,
  body: UpdateAuthorizedClubRequest,
): Promise<AuthorizedClub> {
  return request<AuthorizedClub>(
    `/admin/clubs/${encodeURIComponent(clubname)}`,
    { method: 'PATCH', body, auth },
  )
}
